import json from './sprite.js';

export default {
    handle: 'SP_SPS8-AfterSchool',
    label: 'es_SPS8-AfterSchool_234684001',
    json,
};
